import {LANDLORDS_REQUEST, LANDLORDS_SUCCESS, LANDLORDS_FAILURE} from '../actions';
import {LANDLORD_UPDATE_REQUEST, LANDLORD_UPDATE_SUCCESS, LANDLORD_UPDATE_FAILURE} from '../actions';
import {DOCUMENT_UPLOAD_REQUEST, DOCUMENT_UPLOAD_SUCCESS, DOCUMENT_UPLOAD_FAILURE} from '../actions';
import {DOCUMENT_DELETE_REQUEST, DOCUMENT_DELETE_SUCCESS, DOCUMENT_DELETE_FAILURE} from '../actions';
import landlordReducer from './landlord';

export const LANDLORDS_INITIAL_STATE = {
    isFetching: false,
    data: [],
    links: {},
    meta: {},
    error: null
};

const landlord = (state, action) => {
    const i = state.data.findIndex(a => a.id == action.id);
    const {branches, ...rest} = state.data[i] || {branches: null};
    const landlord = landlordReducer({profile: rest, branches}, action);
    const data = [...state.data];
    data[i == '-1' ? 0 : i] = {...landlord.profile, branches};
    return {...state, data};
};

const landlordsReducers = {
    [LANDLORDS_REQUEST]: (state) => {
        return {...state, isFetching: true, error: null};
    },
    [LANDLORDS_SUCCESS]: (state, {res}) => {
        return {...state, ...res, isFetching: false, error: null};
    },
    [LANDLORDS_FAILURE]: (state, {error}) => {
        return {...state, isFetching: false, error};
    },
    [LANDLORD_UPDATE_REQUEST]: landlord,
    [LANDLORD_UPDATE_SUCCESS]: landlord,
    [LANDLORD_UPDATE_FAILURE]: landlord,
    [DOCUMENT_UPLOAD_REQUEST]: landlord,
    [DOCUMENT_UPLOAD_SUCCESS]: landlord,
    [DOCUMENT_UPLOAD_FAILURE]: landlord,
    [DOCUMENT_DELETE_REQUEST]: landlord,
    [DOCUMENT_DELETE_SUCCESS]: landlord,
    [DOCUMENT_DELETE_FAILURE]: landlord
};

export default function landlords(state = LANDLORDS_INITIAL_STATE, action) {
    let reducer = landlordsReducers[action.type] || (state => state);
    return reducer(state, action);
}


// WEBPACK FOOTER //
// ./resources/assets/js/reducers/landlords.js